import { Checkbox, ListItemText } from '@mui/material';
import React from 'react';

import { checkboxStyles, ControlMenuItem } from './DepartmentFilter.styles';

interface ISelectAllControlProps {
  allSelected: boolean;
  indeterminate: boolean;
  isFocused: boolean;
  onClick: (e: React.MouseEvent) => void;
  onKeyDown: (event: React.KeyboardEvent) => void;
  onRef: (el: HTMLLIElement | null) => void;
  controlMenuItemStyles: React.CSSProperties | object;
}

export const SelectAllControl: React.FC<ISelectAllControlProps> = ({
  allSelected,
  indeterminate,
  isFocused,
  onClick,
  onKeyDown,
  onRef,
  controlMenuItemStyles,
}) => (
  <ControlMenuItem
    disableRipple
    ref={onRef}
    onClick={onClick}
    onKeyDown={onKeyDown}
    tabIndex={isFocused ? 0 : -1}
    sx={controlMenuItemStyles}
    data-action="department_filter_select_all"
  >
    <Checkbox sx={checkboxStyles} checked={allSelected} indeterminate={indeterminate} />
    <ListItemText primary="Select/Deselect all" />
  </ControlMenuItem>
);
